import React from 'react';
import cls from 'classnames';
import { MONTH_NAMES } from '../../../../constants/dates';
import styles from './index.module.scss';
const MonthsPicker = ({ setMonth, setMode, month }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.head },
            React.createElement("button", { type: 'button', onClick: () => setMode('date') }, "Select month")),
        MONTH_NAMES.map((item, i) => (React.createElement("div", { key: item, className: cls(styles.item, {
                [styles.selected]: i === month
            }) },
            React.createElement("button", { type: 'button', onClick: () => {
                    setMonth(i);
                    setMode('date');
                } }, item))))));
};
export default MonthsPicker;
